<main class="c-main" role="main">
    <div class="c-page-confirmationcard">
        <div class="container">
            <div class="row mobile--orange u-pt30 u-pb30">
                <div class="col-md-12" *ngIf="card">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a >{{'CardConfirmationPortal.home' | translate}}</a></li>
                            <li class="breadcrumb-item active" aria-current="page">&nbsp;-&nbsp;</li><span>{{'CardConfirmationPortal.location' | translate}}</span>
                        </ol>
                    </nav>
                    <h2 *ngIf="card.type" class="o-title">{{'CardConfirmationPortal.titleNewCard'| translate}} {{id}}</h2>
                    <h2 *ngIf="!card.type" class="o-title">{{'CardConfirmationPortal.titleReplacement'| translate}} {{id}}</h2>

                </div>
            </div>
        </div>
        <section class="c-results">
            <div class="container u-pt40 u-pb60">
                <div class="row">
                    <div class="col-md-10 col-md-offset-1">
                        <h2 class="o-title o-title--medium o-title--center">{{'CardConfirmationPortal.statusApproved' | translate}}</h2>
                        <div class="o-steps">
                            <div class="row" *ngIf="card">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-offset-1 col-xs-5 o-steps__step o-steps__step--approved">
                                            <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                                            <label>{{'CardConfirmationPortal.step1' | translate}}</label>
                                            <p>{{'CardConfirmationPortal.statusSubmit' | translate}}</p>
                                        </div>

                                        <div class="col-xs-5 o-steps__step" *ngIf="card.status.name==='Pending'">
                                            <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                                            <label>{{'CardConfirmationPortal.step2' | translate}}</label>
                                            <p>{{'CardConfirmationPortal.statusReview' | translate}}</p>
                                        </div>

                                        <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="card.status.name==='Reject'">
                                            <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                                            <label>{{'CardConfirmationPortal.step2' | translate}}</label>
                                            <p>{{'CardConfirmationPortal.statusReject' | translate}} </p>
                                        </div>

                                        <div class="col-xs-5 o-steps__step o-steps__step--approved" *ngIf="card.status.name==='Approved'">
                                            <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                                            <label>{{'CardConfirmationPortal.step2' | translate}}</label>
                                            <p>{{'CardConfirmationPortal.statusClosed' | translate}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="row">
                                <div class="col-md-10 col-md-offset-1">
                                    <div class="u-pt40 u-pb30 u-mb40 center c-results__box">
                                        <h3><span></span> {{'CardConfirmationPortal.workOrder' | translate}} {{id}}</h3>
                                        <p></p>
                                        <p>{{'CardConfirmationPortal.copyEmail' | translate}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="o-text o-text--big center ">{{'CardConfirmationPortal.msgTrack' | translate}}</p>
                        <div class="row u-pt20">
                            <div class="col-md-6 col-md-offset-3" *ngIf="card">
                                <a class="btn btn--full btn--primary" *ngIf="card.type" [routerLink]="['/new-cards/list']">
                                    <!--link to remplacement-->
                                    {{'CardConfirmationPortal.btnCardList' | translate}} </a>
                                <a class="btn btn--full btn--primary" *ngIf="!card.type" [routerLink]="['/new-cards/list']">
                                    <!--link to remplacement-->
                                    {{'CardConfirmationPortal.btnCardList' | translate}} </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</main>